module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/06fbea3e34c66462364944fc91a708c9.png";